import { DesktopHeader, MobileHeader } from '@sravni/react-header';
import { useIsMobile } from '@sravni/react-utils';
import React from 'react';

import { useAppSelector } from 'shared/lib/redux';

import { currentLocationSelector } from 'entities/locations';
import { selectSiteSettingsHeader } from 'entities/siteSettings';
import { accountSelector } from 'entities/user';

export function MainSiteHeader({ fixedBackground }: { fixedBackground: boolean }) {
  const isMobile = useIsMobile();
  const currentRegion = useAppSelector(currentLocationSelector);
  const settings = useAppSelector(selectSiteSettingsHeader);
  const user = useAppSelector(accountSelector);

  if (isMobile) {
    return (
      <MobileHeader
        fixedBackground={fixedBackground}
        enableTheme
        currentRegion={currentRegion}
        settings={settings}
        user={user || undefined}
      />
    );
  }

  return (
    <DesktopHeader
      fixedBackground={fixedBackground}
      enableTheme
      currentRegion={currentRegion}
      settings={settings}
      user={user || undefined}
    />
  );
}
